import { render, staticRenderFns } from "./NewCostEstimatorProjectItemForm.vue?vue&type=template&id=2ca13bd8"
import script from "./NewCostEstimatorProjectItemForm.vue?vue&type=script&lang=js"
export * from "./NewCostEstimatorProjectItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports